var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVolumeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 27.6333V25.5667C21.3222 24.9444 23.0833 23.75 24.45 21.9833C25.8167 20.2167 26.5 18.2111 26.5 15.9667C26.5 13.7222 25.8222 11.7111 24.4667 9.93332C23.1111 8.15554 21.3444 6.96665 19.1667 6.36665V4.29999C21.9222 4.92221 24.1667 6.31665 25.9 8.48332C27.6333 10.65 28.5 13.1444 28.5 15.9667C28.5 18.7889 27.6333 21.2833 25.9 23.45C24.1667 25.6167 21.9222 27.0111 19.1667 27.6333ZM4.5 20V12H9.83333L16.5 5.33332V26.6667L9.83333 20H4.5ZM18.5 21.6V10.3667C19.7222 10.7444 20.6944 11.4555 21.4167 12.5C22.1389 13.5444 22.5 14.7111 22.5 16C22.5 17.2667 22.1333 18.4222 21.4 19.4667C20.6667 20.5111 19.7 21.2222 18.5 21.6Z",
    fill: "#594AE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolumeActive);
export default __webpack_public_path__ + "static/media/icon-volume-active.46dfeee8591cbdf30b68bc5f5acfae29.svg";
export { ForwardRef as ReactComponent };